import identity from "lodash/fp/identity";
import last from "lodash/fp/last";

export default function getVimeoId(url: string) {
  const urlAfterSplit = url.split(
    /(http|https)?:\/\/(www\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|)(\d+)(?:|\/\?)/,
  );

  return last(urlAfterSplit.filter(identity));
}
